import styled from 'styled-components';

import { setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';
import { TextArea } from '../../../../components/TextArea';

export const StyledValuePropWrapper = styled.div`
  padding: 16px;
`;

export const StyledPreferenceTextArea = styled(TextArea)`
  margin-bottom: 4px;
`;

export const StyledPreferenceResetButton = styled(Button)`
  display: inline-flex;
  gap: 8px;
  align-items: center;
  ${setFontVariant('caption')};
`;
